"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDisctimesLogs = createDisctimesLogs;
exports.getDisctimesLogsList = getDisctimesLogsList;
var _request = _interopRequireDefault(require("@/utils/request"));
// 盘次分配明细

function getDisctimesLogsList(query) {
  return (0, _request.default)({
    url: '/system/disctimeslogs/',
    method: 'get',
    params: query
  });
}
function createDisctimesLogs(data) {
  return (0, _request.default)({
    url: '/system/disctimeslogs/',
    method: 'post',
    data: data
  });
}